<template>
  <div class="row">
    <div class="col">
      <!-- Step 1 -->
      <card v-if="step == 1">
        <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
        <form action="#" method="post">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-md-6">
                  <p class="mt-1 text-center text-md-left">
                    EMAIL PARA CONFIRMAÇÃO DE EMBARQUE (*)
                  </p>
                </div>
                <div class="col-md-6">
                  <div class="col-12">
                    <input class="w-100 ml-auto pl-2" id="email" v-model="processo.email" type="text" />
                  </div>
                </div>
              </div>
              <hr class="mt-2" />
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="d-block" for="shipper">SHIPPER</label>
                    <textarea rows="5" class="w-100 ft-11" name="shipper" id="shipper" :maxlength="(70*5)"
                      @keydown="limitarLinhas('shipper', 70, 5)" @change="formatarTexto('shipper', 70, 5)"
                      v-model="processo.shipper"></textarea>
                      <span class="ft-10 ft-red m-0 p-0">Máximo 5 linhas</span><br>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="consignee">CONSIGNEE</label>
                    <textarea rows="5" class="w-100 ft-11" name="consignee" id="consignee" :maxlength="(70*5)"
                      @keydown="limitarLinhas('consignee', 70, 5)" @change="formatarTexto('consignee', 70, 5)"
                      v-model="processo.consignee"></textarea>
                      <span class="ft-10 ft-red m-0 p-0">Máximo 5 linhas</span><br>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="notify">NOTIFY</label>
                    <textarea rows="5" class="w-100 ft-11" name="notify" id="notify" :maxlength="(70*5)"
                      @keydown="limitarLinhas('notify', 70, 5)" @change="formatarTexto('notify', 70, 5)"
                      v-model="processo.notify"></textarea>
                      <span class="ft-10 ft-red m-0 p-0">Máximo 5 linhas</span><br>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="d-block" for="precarriegeby">PRECARRIEGY BY</label>
                    <input class="w-100" name="precarriegeby" id="precarriegeby" v-model="processo.precarriegeby" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="d-block" for="placereceipt">PLACE OF RECEIPT</label>
                    <input class="w-100" name="placereceipt" id="placereceipt" v-model="processo.placereceipt" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="d-block" for="portofloading">PORT OF LOADING</label>
                        <input class="w-100" readonly name="portofloading" id="portofloading"
                          v-model="processo.portofloading" />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label class="d-block" for="portofdischarge">PORT OF DISCHARGE</label>
                        <input class="w-100" readonly name="portofdischarge" id="portofdischarge"
                          v-model="processo.portofdischarge" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="d-block" for="oceanvessel">OCEAN VESSEL</label>
                    <input class="w-100" readonly name="oceanvessel" id="oceanvessel" v-model="processo.oceanvessel" />
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="placeofdelivery">PLACE OF DELIVERY</label>
                    <input class="w-100" readonly name="placeofdelivery" id="placeofdelivery"
                      v-model="processo.placeofdelivery" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="d-block" for="handlinginformation">HANDLING INFORMATION</label>
                    <textarea rows="5" class="w-100" name="handlinginformation" id="handlinginformation" maxlength="400"
                      @keydown="limitarLinhas('handlinginformation', 50, 5)"
                      @change="formatarTexto('handlinginformation', 50, 5)"
                      v-model="processo.handlinginformation"></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="d-block" for="commoditydescription">DESCRIPTION OF GOODS(BRIEF)</label>
                    <textarea rows="5" class="w-100" name="commoditydescription" id="commoditydescription" maxlength="400"
                      @keydown="limitarLinhas('commoditydescription', 50, 5)"
                      @change="formatarTexto('commoditydescription', 50, 5)" v-model="processo.commoditydescription"
                      required></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-12">
                <div class="form-group">
                  <label class="d-block" for="booking">BOOKING</label>
                  <input class="w-100" readonly name="booking" id="booking" v-model="processo.booking" />
                </div>
                <div class="form-group">
                  <label class="d-block" for="embarque">EMBARQUE</label>
                  <input class="w-100" readonly name="embarque" id="embarque" v-model="processo.embarque" />
                </div>

                <div class="form-group">
                  <label class="d-block" for="exportreferences">EXPORT REFERENCES</label>
                  <textarea rows="5" class="w-100" name="exportreferences" id="exportreferences" maxlength="100"
                    @keydown="limitarLinhas('exportreferences', 65, 5)" @change="formatarTexto('exportreferences', 65, 5)"
                    v-model="processo.exportreferences" />
                </div>
                <div class="form-group">
                  <label class="d-block" for="forwardingagent">FORWARDING AGENT</label>
                  <textarea rows="3" class="w-100" name="forwardingagent" id="forwardingagent"
                    @keydown="limitarLinhas('forwardingagent', 65, 5)" @change="formatarTexto('forwardingagent', 65, 5)"
                    v-model="processo.forwardingagent" />
                </div>
                <div class="form-group">
                  <label class="d-block" for="pointandcountry">POINT AND COUNTRY OF ORIGIN OF GOODS</label>
                  <input class="w-100" name="pointandcountry" id="pointandcountry" v-model="processo.pointandcountry" />
                </div>
                <div class="form-group">
                  <label class="d-block" for="ncm">NCM</label>
                  <textarea rows="5" class="w-100" name="ncm" id="ncm" @keydown="limitarLinhas('ncm', 65, 5)"
                    @change="formatarTexto('ncm', 65, 5)" v-model="processo.ncm"></textarea>
                </div>
                <div class="form-group">
                  <label class="d-block" for="due">DUE</label>
                  <input maxlength="20" class="w-100" name="due" id="due" v-model="processo.due" />
                </div>
                <div class="form-group">
                  <label class="d-block" for="ruc">RUC</label>
                  <input maxlength="20" class="w-100" name="ruc" id="ruc" v-model="processo.ruc" />
                </div>
                <div class="form-check">
                  <input type="radio" value="1" name="opt" id="opt1" @change="resetHbl()"
                    v-model="processo.opt_release" />
                  <label class="pl-2" for="opt1">EXPRESS RELEASE</label>
                </div>
                <div class="form-check">
                  <input type="radio" name="opt" value="ORIGINAIS NA ORIGEM" id="opt2" @change="resetRelease()"
                    v-model="processo.hbl_original" />
                  <label class="pl-2" for="opt2">ORIGINAIS NA ORIGEM</label>
                </div>
                <div class="form-check">
                  <input type="radio" name="opt" value="ORIGINAIS NO DESTINO" id="opt3" @change="resetRelease()"
                    v-model="processo.hbl_original" />
                  <label class="pl-2" for="opt3">ORIGINAIS NO DESTINO</label>
                </div>
                <div class="form-check">
                  <input type="radio" name="opt" value="WAYBILL" id="opt4" @change="resetRelease()"
                    v-model="processo.hbl_original" />
                  <label class="pl-2" for="opt4">WAYBILL</label>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-3">
                  <label for="marks">MARKS</label>
                  <textarea class="w-100" v-model="processo.marks" @change="formatarTexto('marks', 23)" name="marks"
                    id="marks" rows="10" cols="23"></textarea>
                </div>
                <div class="col-md-2">
                  <label for="npkgs">N.PKGS</label>
                  <textarea class="w-100" v-model="processo.npkgs" @change="formatarTexto('npkgs', 5)" name="npkgs"
                    id="npkgs" rows="10" cols="50"></textarea>
                </div>
                <div class="col-md-7">
                  <label for="descriptionofgoods">DESCRIPTION OF GOODS (*)
                  </label>
                  <textarea class="w-100" v-model="processo.descriptionofgoods"
                    @change="formatarTexto('descriptionofgoods', processo.charsInRows)" name="descriptionofgoods"
                    id="descriptionofgoods" rows="10" cols="50" wrap="HARD"
                    :maxlength="processo.descriptionsize"></textarea>
                  <p>
                    <span class="ft-10 ft-red m-0 p-0">Qnt. máxima de caractéres: {{ processo.descriptionsize }} caracteres.</span><br>
                    <span class="ft-10 ft-red m-0 p-0">Qnt. de caractéres por linha: {{ processo.charsInRows }} caracteres</span><br>
                  </p>
                </div>
              </div>
              <hr />
              <div class="row">

                <HTableWebDraft class="table-hover table-striped d-print-none" @input-modified="calcularNetWeight"
                  :columns="processo.containers.headers" :data="processo.containers.content"
                  :tiposContainers="processo.containers.tipos" :deleted="processo.containers.deleted"></HTableWebDraft>
              </div>
              <hr />
              <div class="row">
                <div class="col-12 table-responsive table-hover table-striped d-print-none">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>GROSS WEIGHT</th>
                        <th>NET WEIGHT</th>
                        <th>MEASUREMENT</th>
                        <th>QUANTITY</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ calcularWeight() }}</td>
                        <td>
                          <input :disabled="processo.net_weight > 0 ? true : false" class="ft-10" type="number"
                            name="net_weight" id="net_weight" v-model="processo.net_weight" step="any" />
                        </td>
                        <td>{{ calcularMeasurement() }}</td>
                        <td>{{ calcularQuantity() }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <div class="row d-flec justify-content-between">
                <div class="col-md-4 text-center d-print-none">
                  <button type="text" @click.prevent="atualizarProcesso(true)"
                    class="btn btn-info w-100 btn-fill mb-4btn-blue">
                    Visualizar e Confirmar
                  </button>
                </div>
                <div class="col-md-4 text-center d-print-none">
                  <button type="text" @click.prevent="atualizarProcesso" class="btn btn-success btn-fill w-100">
                    Salvar
                  </button>
                </div>
              </div>
            </div>
            <!-- <pre style="border:none;" class="break-row">{{capa}}</pre> -->
          </div>
        </form>
      </card>
      <!-- Step 2 -->
      <card class="mb-2" v-if="step == 2 || step == 4 || step == 5">

        <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
        <!-- FORMULÁRIO DE CADASTRO DRAFT -->
        <form action="#" method="post">
          <div class="row">
            <div class="col-12">
              <div id="conteudo-email" class="row">

                <div class="col-12">
                  <h3 class="empresa-left text-center text-md-left">{{ this.empresaInfo.nomeEmpresa }}</h3>
                  <hr />
                </div>

                <!-- ROW UNICA - EMAIL -->
                <div class="col-12">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="email-left mt-1 text-center text-md-left">
                        EMAIL PARA CONFIRMAÇÃO DE ENVIO DE DRAFT (*)
                      </p>
                    </div>
                    <div class="col-md-6">
                      <div class="col-12">
                        <pre style="border: none" class="break-row">{{
                          processo.email
                        }}</pre>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2" />
                </div>
                <!-- COL1 - SHIPPER -->
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="d-block font-weight-bold" for="shipper">SHIPPER</label>
                        <pre style="border: none" class="break-row">{{
                          processo.shipper
                        }}</pre>
                      </div>
                      <div class="form-group">
                        <label class="d-block font-weight-bold" for="consignee">CONSIGNEE</label>
                        <pre style="border: none" class="break-row">{{
                          processo.consignee
                        }}</pre>
                      </div>
                      <div class="form-group">
                        <label class="d-block font-weight-bold" for="notify">NOTIFY</label>
                        <pre style="border: none" class="break-row">{{
                          processo.notify
                        }}</pre>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="d-block font-weight-bold" for="precarriegeby">PRECARRIEGY BY</label>
                        <pre style="border: none" class="break-row">{{
                          processo.precarriegeby
                        }}</pre>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="form-group">
                          <label class="d-block font-weight-bold" for="placereceipt">PLACE OF RECEIPT</label>
                          <pre style="border: none" class="break-row">{{
                            processo.placereceipt
                          }}</pre>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label class="d-block font-weight-bold" for="portofloading">PORT OF LOADING</label>
                            <pre style="border: none" class="break-row">{{
                              processo.portofloading
                            }}</pre>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="d-block font-weight-bold" for="portofdischarge">PORT OF DISCHARGE</label>
                            <pre style="border: none" class="break-row">{{
                              processo.portofdischarge
                            }}</pre>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="d-block font-weight-bold" for="handlinginformation">HANDLING INFORMATION</label>
                            <pre style="border: none" class="break-row">{{
                              processo.handlinginformation
                            }}</pre>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="d-block font-weight-bold" for="oceanvessel">OCEAN VESSEL</label>
                        <pre style="border: none" class="break-row">{{
                          processo.oceanvessel
                        }}</pre>
                      </div>
                      <div class="form-group">
                        <label class="d-block font-weight-bold" for="placeofdelivery">PLACE OF DELIVERY</label>
                        <pre style="border: none" class="break-row">{{
                          processo.placeofdelivery
                        }}</pre>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- COL2 - BOOKING  -->
                <div class="col-md-6">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="booking">BOOKING</label>
                      <pre style="border: none" class="break-row">{{
                        processo.booking
                      }}</pre>
                    </div>
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="embarque">EMBARQUE</label>
                      <pre style="border: none" class="break-row">{{
                        processo.embarque
                      }}</pre>
                    </div>

                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="exportreferences">EXPORT REFERENCES</label>
                      <pre style="border: none" class="break-row">{{
                        processo.exportreferences
                      }}</pre>
                    </div>
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="forwardingagent">FORWARDING AGENT</label>
                      <pre style="border: none" class="break-row">{{
                        processo.forwardingagent
                      }}</pre>
                    </div>
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="pointandcountry">POINT AND COUNTRY OF ORIGIN OF
                        GOODS</label>
                      <pre style="border: none" class="break-row">{{
                        processo.pointandcountry
                      }}</pre>
                    </div>
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="ncm">NCM</label>
                      <pre style="border: none" class="break-row">{{
                        processo.ncm
                      }}</pre>
                    </div>
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="due">DUE</label>
                      <pre style="border: none" class="break-row">{{
                        processo.due
                      }}</pre>
                    </div>
                    <div class="form-group">
                      <label class="d-block font-weight-bold" for="ruc">RUC</label>
                      <pre style="border: none" class="break-row">{{
                        processo.ruc
                      }}</pre>
                    </div>
                    <div class="form-group" v-if="processo.opt_release > 0">
                      <label class="d-block font-weight-bold" for="ruc">Label</label>
                      <pre style="border: none">EXPRESS RELEASE</pre>
                    </div>
                    <div class="form-group" v-if="processo.hbl_original == 'ORIGINAIS NA ORIGEM'">
                      <pre style="border: none">ORIGINAIS NA ORIGEM</pre>
                    </div>
                    <div class="form-group" v-if="processo.hbl_original == 'ORIGINAIS NO DESTINO'">
                      <pre style="border: none">ORIGINAIS NO DESTINO</pre>
                    </div>
                    <div class="form-group" v-if="processo.hbl_original == 'WAYBILL'">
                      <pre style="border: none">WAYBILL</pre>
                    </div>
                  </div>
                </div>
                <!-- PAGE BREAK -->
                <div class="col-12 page-break">
                  <hr />
                </div>
                <!-- MARKS, PKGS, DESCRIPTION -->
                <div class="col-12">
                  <!-- INFO 2 -->
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <label class="font-weight-bold" for="marks">MARKS 1</label>
                          <pre style="border: none" class="ft-12">{{ processo.marksShipment }}</pre>
                        </div>
                        <div class="col-md-6">
                          <label class="font-weight-bold" for="npkgs">N.PKGS</label>
                          <pre style="border: none" class="">{{
                            processo.npkgs
                          }}</pre>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-12">
                          <label class="font-weight-bold" for="descriptionofgoods">DESCRIPTION OF GOODS (*)
                          </label>
                          <pre style="border: none">{{ processo.descriptionofgoods }}</pre>
                          <p>
                            <span class="ft-10 ft-red m-0 p-0">Qnt. máxima de caractéres: {{ processo.descriptionsize }} caracteres.</span><br>
                            <span class="ft-10 ft-red m-0 p-0">Qnt. de caractéres por linha: {{ processo.charsInRows }} caracteres</span><br>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- FIM INFO 2 -->
                  <!-- CONTAINERS -->
                  <hr class="d-print-none" />
                  <div class="row">
                    <div class="col-12 table-responsive">
                      <table class="table">
                        <thead>
                          <slot name="columns">
                            <tr>
                              <th v-for="column in processo.containers.headers" :key="column">
                                {{ column }}
                              </th>
                            </tr>
                          </slot>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in processo.containers.content" :key="index">
                            <slot :row="item">
                              <td v-for="column in processo.containers.headers" :key="column">
                                <pre style="border: none">{{
                                  processo.containers.content[index][column]
                                }}</pre>
                              </td>
                            </slot>
                          </tr>
                          <!-- <tr>
                              <td v-for="column in columns" :key="column">
                                  <input type="text" id="column" class="w-100 ft-10"/>
                              </td>
                          </tr> -->
                        </tbody>
                      </table>
                    </div>
                    <hr />
                    <div class="col-12 table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>GROSS WEIGHT</th>
                            <th>NET WEIGHT</th>
                            <th>MEASUREMENT</th>
                            <th>QUANTITY</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <pre style="border: none">{{
                                calcularWeight()
                              }}</pre>
                            </td>
                            <td>
                              <pre style="border: none">{{
                                processo.net_weight
                              }}</pre>
                            </td>
                            <td>
                              <pre style="border: none">{{
                                calcularMeasurement()
                              }}</pre>
                            </td>
                            <td>
                              <pre style="border: none">{{
                                calcularQuantity()
                              }}</pre>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- FIM CONTAINERS -->
                </div>
              </div>
            </div>

            <!-- BOTÕES E AÇOES FINAIS -->
            <div class="col-12">
              <div class="row d-flec justify-content-between">
                <div class="col-md-4 text-center d-print-none">
                  <button v-if="step == 2" type="text" @click.prevent="reverEtapa"
                    class="btn btn-info btn-fill w-100 mb-4btn-blue">
                    Corrigir
                  </button>
                </div>
                <div class="col-md-4 text-center d-print-none">
                  <button v-if="step == 2 && !processo.isf.is_enable_isf"
                    class="btn btn-success btn-fill w-100 mb-2 d-print-none"
                    @click.prevent="imprimirDetalhes(efetivarProcesso)">
                    Enviar Draft
                  </button>
                  <button v-if="step == 2 && processo.isf.is_enable_isf"
                    class="btn btn-success btn-fill w-100 mb-2 d-print-none" @click.prevent="avancarEtapa(true)">
                    Preencher ISF
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </card>
      <!-- Step 3 -->
      <card v-if="step == 3">
        <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
        <form action="#" method="post">
          <div class="row">
            <div class="col-md-12">
              <h3>ISF - IMPORT SECURITY FILLING</h3>
              <hr class="mt-2" />
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="d-block" for="isf_remarks">REMARKS</label>

                    <textarea rows="5" class="w-100" name="isf_remarks" id="isf_remarks" maxlength="400"
                      @keydown="limitarLinhas('isf_remarks', 65, 5)" @change="formatarTexto('isf_remarks', 65, 5)"
                      v-model="processo.isf.isf_remarks"></textarea>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="isf_manufacturer">MANUFACTURER (NAME AND ADDRESS) *</label>
                    <span class="dfl mt-0 mb-2">
                      (Defined as the Name & Address of the party who last manufacturered/assembled <br>
                      /grew/produced the goods OR the Name & Address of the Supplier of the Finished <br>
                      Merchandise in the country from which the goods are exiting)
                    </span>
                    <textarea rows="5" class="w-100" name="isf_manufacturer" id="isf_manufacturer" maxlength="400"
                      @keydown="limitarLinhas('isf_manufacturer', 50, 5)"
                      @change="formatarTexto('isf_manufacturer', 50, 5)"
                      v-model="processo.isf.isf_manufacturer"></textarea>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="isf_seller">SELLER (NAME AND ADDRESS) *</label>
                    <span class="dfl mt-0 mb-2">
                      (Defined as the Name &amp; Address of the last known entity by whom the merchandise <br>
                      is sold or is agreed to be sold) <br>
                    </span>
                    <textarea rows="5" class="w-100" name="isf_seller" id="isf_seller" maxlength="400"
                      @keydown="limitarLinhas('isf_seller', 50, 5)" @change="formatarTexto('isf_seller', 50, 5)"
                      v-model="processo.isf.isf_seller"></textarea>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="isf_buyer">BUYER (NAME AND ADDRESS) *</label>
                    <span class="dfl mt-0 mb-2">
                      (Defined as the Name & Address of the last known entity to whom the merchandise <br>
                      is sold or is agreed to be sold)
                    </span>
                    <textarea rows="5" class="w-100" name="isf_buyer" id="isf_buyer" maxlength="400"
                      @keydown="limitarLinhas('isf_buyer', 50, 5)" @change="formatarTexto('isf_buyer', 50, 5)"
                      v-model="processo.isf.isf_buyer"></textarea>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="isf_ship">SHIP TO (NAME AND ADDRESS) *</label>
                    <span class="dfl mt-0 mb-2">
                      (Defined as the Name & Address of the first party scheduled to receive the <br>
                      merchandise, oncereleased by CBP (Customs & Border Protection) Note - <br>
                      Customs requires the actual deliver to name and address - not a corporate location)
                    </span>
                    <textarea rows="5" class="w-100" name="isf_ship" id="isf_ship" maxlength="400"
                      @keydown="limitarLinhas('isf_ship', 50, 5)" @change="formatarTexto('isf_ship', 50, 5)"
                      v-model="processo.isf.isf_ship"></textarea>
                  </div>
                  <div class="form-group">
                    <label class="d-block" for="isf_container">CONTAINER STUFFING (NAME AND ADDRESS) *</label>
                    <span class="dfl mt-0 mb-2">
                      (Defined as the Name & Address of the location(s) where the goods were stuffed into the container.
                      <br>
                      Scheduled stuffing location is acceptable and may be the same name and address as the manufacturer
                      <br>
                      or supplier, depending)
                    </span>
                    <textarea rows="5" class="w-100" name="isf_container" id="isf_container" maxlength="400"
                      @keydown="limitarLinhas('isf_container', 50, 5)" @change="formatarTexto('isf_container', 50, 5)"
                      v-model="processo.isf.isf_container"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-12">
                <div class="form-group">
                  <label class="d-block" for="isf_consolidator">CONSOLIDATOR LOCATION (NAME AND ADDRESS) *</label>
                  <span class="dfl mt-0 mb-2">
                    (Defined as the Name & Address of the party who either stuffed the container <br>
                    or who arranged for the stuffing of the container)
                  </span>
                  <textarea rows="5" class="w-100" name="isf_consolidator" id="isf_consolidator" maxlength="400"
                    @keydown="limitarLinhas('isf_consolidator', 50, 5)" @change="formatarTexto('isf_consolidator', 50, 5)"
                    v-model="processo.isf.isf_consolidator"></textarea>
                </div>
                <div class="form-group">
                  <label class="d-block" for="isf_importer">IMPORTER OF RECORD (NAME AND ADDRESS AND EIN/GTZ) *</label>
                  <span class="dfl mt-0 mb-2">
                    (Defined as the Party liable for payment of all duties and responsible for <br>
                    meeting all requirements for importation of goods; Acceptable: IRS Number, <br>
                    EIN Number, Social Security Number, or CBP Assigned Number)
                  </span>
                  <textarea rows="5" class="w-100" name="isf_importer" id="isf_importer" maxlength="400"
                    @keydown="limitarLinhas('isf_importer', 50, 5)" @change="formatarTexto('isf_importer', 50, 5)"
                    v-model="processo.isf.isf_importer"></textarea>
                </div>
                <div class="form-group">
                  <label class="d-block" for="isf_cnee">CONSIGNEE (NAME AND ADDRESS AND EIN) *</label>
                  <span class="dfl mt-0 mb-2">
                    (Defined as the Individual or Firm in the United States on whose account <br>
                    the goods are shipped; Acceptable: IRS Number, EIN Number, Social Security <br>
                    Number,or CBP Assigned Number)) <br>
                  </span>
                  <textarea rows="5" class="w-100" name="isf_cnee" id="isf_cnee" maxlength="400"
                    @keydown="limitarLinhas('isf_cnee', 50, 5)" @change="formatarTexto('isf_cnee', 50, 5)"
                    v-model="processo.isf.isf_cnee"></textarea>
                </div>
                <div class="form-group">
                  <label class="d-block" for="isf_country">COUNTRY OF ORIGIN AT THE LINE LEVEL *</label>
                  <span class="dfl mt-0 mb-2">
                    (Defined as the Country of Manufacture, Production, or Growth of the goods)
                  </span>
                  <textarea rows="5" class="w-100" name="isf_country" id="isf_country" maxlength="400"
                    @keydown="limitarLinhas('isf_country', 50, 5)" @change="formatarTexto('isf_country', 50, 5)"
                    v-model="processo.isf.isf_country"></textarea>
                </div>
                <div class="form-group">
                  <label class="d-block" for="isf_hts">HTS TO THE 6-DIGIT AT THE LOWEST B/L LEVEL *</label>
                  <span class="dfl mt-0 mb-2">
                    (Defined as the HTS # (Harmonized Tariff Schedule of the US)the goods are <br>
                    classified as, to the 6th digit)
                  </span>
                  <textarea rows="5" class="w-100" name="isf_hts" id="isf_hts" maxlength="400"
                    @keydown="limitarLinhas('isf_hts', 50, 5)" @change="formatarTexto('isf_hts', 50, 5)"
                    v-model="processo.isf.isf_hts"></textarea>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 text-center">
              <div class="row d-flec justify-content-between">
                <div class="col-md-4 text-center d-print-none">
                  <button type="text" @click.prevent="atualizarISF(true)"
                    class="btn btn-info w-100 btn-fill mb-4btn-blue">
                    Visualizar e Confirmar
                  </button>
                </div>
                <div class="col-md-4 text-center d-print-none">
                  <button type="text" @click.prevent="reverEtapa" class="btn btn-secondary btn-fill w-100">
                    Verificar Draft
                  </button>
                </div>
                <div class="col-md-4 text-center d-print-none">
                  <button type="text" @click.prevent="atualizarISF" class="btn btn-success btn-fill w-100">
                    Salvar
                  </button>
                </div>
              </div>
            </div>
            <!-- <pre style="border:none;" class="break-row">{{capa}}</pre> -->
          </div>
        </form>
      </card>
      <!-- Step 4 -->
      <card class="page-break" style="page-break-before: always" v-if="step == 4 || step == 5">
        <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
        <!-- FORMULÁRIO DE CADASTRO DRAFT -->
        <form action="#" method="post">
          <div class="row">
            <div class="col-md-12">
              <h3>ISF - IMPORT SECURITY FILLING</h3>
              <hr class="mt-2" />
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="d-block font-weight-bold" for="isf_remarks">REMARKS</label>
                    <pre style="border: none" class="break-row">{{
                      processo.isf.isf_remarks
                    }}</pre>
                  </div>
                  <div class="form-group">
                    <label class="d-block font-weight-bold" for="isf_manufacturer">MANUFACTURER (NAME AND ADDRESS)
                      *</label>
                    <pre style="border: none" class="break-row">{{
                      processo.isf.isf_manufacturer
                    }}</pre>
                  </div>
                  <div class="form-group">
                    <label class="d-block font-weight-bold" for="isf_seller">SELLER (NAME AND ADDRESS) *</label>
                    <pre style="border: none" class="break-row">{{
                      processo.isf.isf_seller
                    }}</pre>
                  </div>
                  <div class="form-group">
                    <label class="d-block font-weight-bold" for="isf_buyer">BUYER (NAME AND ADDRESS) *</label>
                    <pre style="border: none" class="break-row">{{
                      processo.isf.isf_buyer
                    }}</pre>
                  </div>
                  <div class="form-group font-weight-bold">
                    <label class="d-block" for="isf_ship">SHIP TO (NAME AND ADDRESS) *</label>
                    <pre style="border: none" class="break-row">{{
                      processo.isf.isf_ship
                    }}</pre>
                  </div>
                  <div class="form-group font-weight-bold">
                    <label class="d-block" for="isf_container">CONTAINER STUFFING (NAME AND ADDRESS) *</label>
                    <pre style="border: none" class="break-row">{{
                      processo.isf.isf_container
                    }}</pre>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-12">
                <div class="form-group">
                  <label class="d-block font-weight-bold" for="isf_consolidator">CONSOLIDATOR LOCATION (NAME AND ADDRESS)
                    *</label>
                  <pre style="border: none" class="break-row">{{
                    processo.isf.isf_consolidator
                  }}</pre>
                </div>
                <div class="form-group">
                  <label class="d-block font-weight-bold" for="isf_importer">IMPORTER OF RECORD (NAME AND ADDRESS AND
                    EIN/GTZ) *</label>
                  <pre style="border: none" class="break-row">{{
                    processo.isf.isf_importer
                  }}</pre>
                </div>
                <div class="form-group">
                  <label class="d-block font-weight-bold" for="isf_cnee">CONSIGNEE (NAME AND ADDRESS AND EIN) *</label>
                  <pre style="border: none" class="break-row">{{
                    processo.isf.isf_cnee
                  }}</pre>
                </div>
                <div class="form-group">
                  <label class="d-block font-weight-bold" for="isf_country">COUNTRY OF ORIGIN AT THE LINE LEVEL *</label>
                  <pre style="border: none" class="break-row">{{
                    processo.isf.isf_country
                  }}</pre>
                </div>
                <div class="form-group">
                  <label class="d-block font-weight-bold" for="isf_hts">HTS TO THE 6-DIGIT AT THE LOWEST B/L LEVEL
                    *</label>
                  <pre style="border: none" class="break-row">{{
                    processo.isf.isf_hts
                  }}</pre>
                </div>
              </div>
            </div>
            <!-- BOTÕES E AÇOES FINAIS -->
            <div class="col-12">
              <div class="row d-flec justify-content-between">
                <div class="col-md-4 text-center d-print-none">
                  <button v-if="step == 4" type="text" @click.prevent="reverEtapa"
                    class="btn btn-info btn-fill w-100 mb-4btn-blue">
                    Corrigir
                  </button>
                </div>
                <div class="col-md-4 text-center d-print-none">
                  <button v-if="step == 4" class="btn btn-success btn-fill w-100 mb-2 d-print-none"
                    @click.prevent="imprimirDetalhes(efetivarProcesso);">
                    Enviar Draft
                  </button>
                </div>
              </div>
            </div>
            <!-- <pre style="border:none;" class="break-row">{{capa}}</pre> -->
          </div>
        </form>
      </card>
      <!-- Step 5 -->
      <card class="mb-4" v-if="step == 6">
        <h2 class="text-center">Processo atualizado.</h2>
      </card>
      <!-- Step 6 -->
      <card class="mb-4" v-if="step == 7">
        <h2 class="text-center">Processo enviado com sucesso.</h2>
      </card>
    </div>
  </div>
</template>
<script>
import HTable from "src/components/TableContainerWebDraft.vue";
import HTableWebDraft from "src/components/TableContainerWebDraft.vue";
import Card from "src/components/Cards/Card.vue";

export default {
  name: "Edicao",
  props: ["capa", "loginInfo"],
  components: {
    HTable,
    HTableWebDraft,
    Card,
  },
  data() {
    return {
      step: 1,
      erro: "",
      isLoading: false,
      fullPage: false,
      empresaInfo: {
        logoEmpresa: "",
        nomeEmpresa: "",
      },
      processo: {
        id: this.capa.dadosGerais.ID_PROCESSO || "",
        processo: this.capa.dadosGerais.PROCESSO || "",
        email: this.loginInfo.user[0] || null,
        id_operador: this.capa.dadosGerais.ID_OPERADOR || "",
        email_operador: this.capa.dadosGerais.EMAIL_OPERADOR || "",
        shipper: this.capa.dadosGerais.SHIPPER || null,
        consignee: this.capa.dadosGerais.CONSIGNEE || null,
        notify: this.capa.dadosGerais.NOTIFY || null,
        precarriegeby: this.capa.dadosGerais.PRE_CARRIAGE || "",
        placereceipt: this.capa.dadosGerais.PLACE_RECEIPT || "",
        portofloading: this.capa.dadosGerais.PORT_LOADING || "",
        portofdischarge: this.capa.dadosGerais.PORT_DISCHARGE || "",
        handlinginformation: this.capa.dadosGerais.HANDLING_INFORMATION || "",
        commoditydescription: this.capa.dadosGerais.COMMODITY_DESCRIPTION || "",
        oceanvessel: this.capa.dadosGerais.VESSEL || "",
        placeofdelivery: this.capa.dadosGerais.PLACE_DELIVERY || "",
        booking: this.capa.dadosGerais.BOOKING || "",
        embarque: this.capa.dadosGerais.EMBARQUE || "",
        exportreferences: this.capa.dadosGerais.REFERENCE || "",
        forwardingagent: this.capa.dadosGerais.FORWARDING_AGENT || "",
        pointandcountry: this.capa.dadosGerais.ORIGIN || "",
        ncm: this.capa.dadosGerais.NCM || "",
        due: this.capa.dadosGerais.DUE || "",
        ruc: this.capa.dadosGerais.RUC || "",
        net_weight: this.capa.dadosGerais.NET_WEIGHT || 0,
        gross_weight: this.capa.dadosGerais.GROSS_WEIGHT || 0,
        measurement: this.capa.dadosGerais.GROSS_WEIGHT || 0,
        opt_release: this.capa.dadosGerais.OPT_RELEASE || 0,
        hbl_original: this.capa.dadosGerais.HBL_ORIGINAL || "",
        marks: this.capa.dadosGerais.MARKS || "",
        marksShipment: this.capa.dadosGerais.MARKSSHIPMENT || "",
        npkgs: this.capa.dadosGerais.NUM_PACKAGES || "",
        descriptionofgoods: this.capa.dadosGerais.DESCRIPTION || null,
        clientes: this.capa.dadosGerais.CLIENTES,
        containers: {
          headers: [
            "TYPE",
            "NUMBER",
            "NET_WEIGHT",
            "SEAL1",
            "SEAL2",
            "SEAL3",
            "TARA",
            "GROSSWEIGHT",
            "CBM",
            "VOLUMES",
          ],
          tipos: this.capa.tiposContainers,
          content: this.capa.containers,
          deleted: [],
        },
        descriptionsize: this.capa.descriptionSize,
        charsInRows: this.capa.charsInRows,
        isf: {
          is_enable_isf: this.capa.dadosGerais.IS_ENABLE_ISF || null,
          isf_remarks: this.capa.dadosGerais.ISF_REMARKS || null,
          isf_manufacturer: this.capa.dadosGerais.ISF_MANUFACTURER || null,
          isf_seller: this.capa.dadosGerais.ISF_SELLER || null,
          isf_buyer: this.capa.dadosGerais.ISF_BUYER || null,
          isf_ship: this.capa.dadosGerais.ISF_SHIP || null,
          isf_container: this.capa.dadosGerais.ISF_CONTAINER || null,
          isf_consolidator: this.capa.dadosGerais.ISF_CONSOLIDATOR || null,
          isf_importer: this.capa.dadosGerais.ISF_IMPORTER || null,
          isf_cnee: this.capa.dadosGerais.ISF_CNEE || null,
          isf_country: this.capa.dadosGerais.ISF_COUNTRY || null,
          isf_hts: this.capa.dadosGerais.ISF_HTS || null
        },
      },
    };
  },
  methods: {
    forceUppercase(value) {
      if (typeof value == "string") {
        return value.toUpperCase();
      }
      return value;
    },
    titleCard(valor) {
      if (valor) {
        return " - " + valor;
      } else {
        return "";
      }
    },
    resetRelease() {
      this.processo.opt_release = null;
    },
    resetHbl() {
      this.processo.hbl_original = null;
    },
    checkEmpresaInfo() {
      let info = JSON.parse(sessionStorage.getItem("empresaInfo"));
      if (info) {
        if (info.hasOwnProperty("LINK")) {
          if (info.LINK != "" && info.LINK != null)
            this.empresaInfo.logoEmpresa = info.LINK;
        }
        if (info.hasOwnProperty("NOME")) {
          if (info.NOME != "" && info.NOME != null)
            this.empresaInfo.nomeEmpresa = info.NOME;
        }
      }
    },
    prepararMarks() {

      let concatText = '';
      this.processo.containers.content.forEach(element => {
        concatText += "\r\n";
        concatText += element['NUMBER'] ? "\r\nNUMBER:" + element['NUMBER'] : '';
        concatText += element['SEAL1'] ? "\r\nSEAL1:" + element['SEAL1'] : '';
        concatText += element['SEAL2'] ? "\r\nSEAL2:" + element['SEAL2'] : '';
        concatText += element['SEAL3'] ? "\r\nSEAL3:" + element['SEAL3'] : '';
        concatText += element['TARA'] ? "\r\nTARA:" + element['TARA'] : '';
        concatText += element['GROSSWEIGHT'] ? "\r\nGROSSWEIGHT:" + element['GROSSWEIGHT'] : '';
        concatText += element['NET_WEIGHT'] ? "\r\nNET_WEIGHT:" + element['NET_WEIGHT'] : '';
        concatText += element['CBM'] ? "\r\nCBM:" + element['CBM'] : '';
        concatText += element['VOLUMES'] ? "\r\nVOLUMES:" + element['VOLUMES'] : '';
      });

      this.processo.marksShipment = this.processo.marks;
      this.processo.marksShipment += concatText;
    },
    formatarTexto(campo, maxLength, maxRows) {


      this.limitarLinhas(campo,maxLength,maxRows);

      let i = 0;
      let mLength = 50;
      let lines = event.target.value.split(/(\r\n|\n|\r)/gm);
      let mRows = lines.length;
      let ultimaQuebra;
      let resto;
      let lines_nova = Array();
      let cont = 0;

      if (campo) {
        lines = document.getElementById(campo).value.split(/(\r\n|\n|\r)/gm);
        mRows = lines.length;
      }

      if (maxLength) {
        mLength = maxLength;
      }

      if (maxRows) {
        mRows = maxRows + 4;
      }

      do {
        if (
          i === mRows ||
          (i == lines.length && lines.length <= maxRows) ||
          lines.length == i
        ) {
          break;
        }
        // Percorre todas as linhas
        // Verifica se a linha é maior que o valor maximo
        if (lines[i].length > mLength) {
          // Percorre a linha quebrando em linhas de (valor maximo) caracteres
          for (var char in lines[i]) {
            if (char % mLength == 0 && char != 0) {
              // Cria um novo Array com a nova linha
              lines_nova[cont] =
                lines[i].substring(ultimaQuebra, char) + "\r\n";
              ultimaQuebra = char;
              cont++;
            }
          }
          // verifica se existe resto e adiciona em uma nova linha
          resto = lines[i].substring(ultimaQuebra);
          if (resto.length > 0) {
            lines_nova[cont] = resto;
            cont++;
          }
          // Caso a linha não seja maior que 50 caracteres, verifica se ela é maior que 0
        } else if (lines[i].length > 0 && lines[i] != "") {
          lines_nova[cont] = lines[i].substring(0);
          cont++;
        }

        ultimaQuebra = 0;
        i++;

        if (campo) {
          this.processo[campo] = lines_nova.join("").toUpperCase();
        } else {
          event.target.value = lines_nova.join("").toUpperCase();
        }
      } while (i < mRows || lines[i + 1]);
    },
    limitarLinhas(name, cols, rows) {
      var limit = rows + 4; // <---max no of lines you want in textarea
      var textarea = document.getElementById(name);
      var spaces = cols;

      var lines = textarea.value.split(/(\r\n|\n|\r)/gm);
      if (lines.length > limit) {
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].length <= spaces) continue;
          var j = 0;

          var space = spaces;

          while (j++ <= spaces) {
            if (lines[i].charAt(j) === " ") space = j;
          }
          lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
          lines[i] = lines[i].substring(0, space);
        }
        if (lines.length > limit) {
          textarea.style.color = "red";
          setTimeout(function () {
            textarea.style.color = "";
          }, 500);
        }
        textarea.value = lines.slice(0, limit).join("").toUpperCase();
      }
    },
    avancarEtapa() {
      this.step++;
    },
    reverEtapa() {
      this.step--;
    },
    escolherEtapa(step) {
      this.step = step;
    },
    atualizarProcesso(avancar) {
      if (this.checkForm() != false) {
        this.formatarTexto("descriptionofgoods", 50);
        this.formatarTexto("marks", 23);
        this.formatarTexto("npkgs", 5);
        this.formatarTexto("shipper", 70, 5);
        this.formatarTexto("consignee", 70, 5);
        this.formatarTexto("notify", 70, 5);
        this.formatarTexto("exportreferences", 65, 5);
        this.formatarTexto("ncm", 65, 5);
        this.prepararMarks();
        this.isLoading = true;
        let loginInfo = this.loginInfo;
        let processo = this.processo;
        let data = { loginInfo, processo };
        var url = this.$urlApi + "/api/processowebdraft-edicao-atualizar";
        this.axios.post(url, data).then((res) => {
          console.log(res);
          this.isLoading = false;
          avancar == true ? this.avancarEtapa() : false; // this.escolherEtapa(6);
        });
      }
    },
    atualizarISF(avancar) {
      if (this.checkFormISF() != false) {
        this.formatarTexto('isf_remarks', 50);
        this.formatarTexto('isf_manufacturer', 50);
        this.formatarTexto('isf_seller', 50);
        this.formatarTexto('isf_buyer', 50);
        this.formatarTexto('isf_ship', 50);
        this.formatarTexto('isf_container', 50);
        this.formatarTexto('isf_consolidator', 50);
        this.formatarTexto('isf_importer', 50);
        this.formatarTexto('isf_cnee', 50);
        this.formatarTexto('isf_country', 50);
        this.formatarTexto('isf_hts', 50);
        this.isLoading = true;
        let loginInfo = this.loginInfo;
        let processo = this.processo;
        let updateISF = true;
        let data = { loginInfo, processo, updateISF };
        var url = this.$urlApi + "/api/processowebdraft-edicao-atualizar";
        this.axios.post(url, data).then((res) => {
          console.log(res);
          this.isLoading = false;
          avancar == true ? this.avancarEtapa() : false; // this.escolherEtapa(5);
        });
      }
    },
    efetivarProcesso() {
      this.isLoading = true;
      let loginInfo = this.loginInfo;
      let processo = this.processo;
      let data = { loginInfo, processo };
      var url = this.$urlApi + "/api/processowebdraft-edicao-efetivar";
      this.axios.post(url, data).then((res) => {
        this.isLoading = false;
        this.enviarEmailDeConfirmação();
      });

    },
    enviarEmailDeConfirmação() {
      this.isLoading = true;
      let loginInfo = this.loginInfo;
      let processo = {
        processo: this.processo.processo,
        email_operador: this.processo.email_operador,
        email: this.processo.email,
        booking: this.processo.booking
      };
      let html = document.getElementById("conteudo-email").outerHTML;
      let data = { loginInfo, processo, html };
      var url = this.$urlApi + "/api/send-email";
      this.axios.post(url, data).then((res) => {
        this.isLoading = false;
        this.escolherEtapa(7);
        this.$emit("fechar");
      });
    },
    imprimirDetalhes(callback) {
      this.step = 5;
      this.$htmlToPaper("print");
      if (callback) {
        callback();
      }
    },
    checkForm() {
      let containerCheck;
      this.processo.containers.content.forEach((element) => {
        if (!element.TYPE) {
          containerCheck = true;
        }
      });

      if (
        this.processo.shipper &&
        this.processo.consignee &&
        this.processo.notify &&
        this.processo.descriptionofgoods &&
        this.processo.email &&
        !containerCheck
      ) {
        return true;
      }

      this.errors = "";

      if (!this.processo.shipper) {
        this.errors += "O SHIPPER é obrigatório. \r\n";
      }
      if (!this.processo.consignee) {
        this.errors += "O CONSIGNEE é obrigatório. \r\n";
      }
      if (!this.processo.notify) {
        this.errors += "O NOTIFY é obrigatório. \r\n";
      }
      if (!this.processo.descriptionofgoods) {
        this.errors += "O DESCRIPTION OF GOODS é obrigatório. \r\n";
      }
      if (!this.processo.email) {
        this.errors += "O EMAIL é obrigatório. \r\n";
      }

      if (containerCheck) {
        this.errors +=
          "Todos os Containers devem ter um tipo selecionado. \r\n";
      }

      alert(this.errors);
      return false;
    },
    calcularNetWeight() {
      let soma = 0;
      this.processo.containers.content.forEach(element => {
        soma += parseFloat(element.NET_WEIGHT);
      });
      this.processo.net_weight = soma > 0 ? soma : 0;
    },
    checkFormISF() {

      if (
        this.processo.isf.isf_manufacturer &&
        this.processo.isf.isf_seller &&
        this.processo.isf.isf_buyer &&
        this.processo.isf.isf_ship &&
        this.processo.isf.isf_container &&
        this.processo.isf.isf_consolidator &&
        this.processo.isf.isf_importer &&
        this.processo.isf.isf_cnee &&
        this.processo.isf.isf_country &&
        this.processo.isf.isf_hts
      ) {
        return true;
      }

      this.errors = "";

      if (!this.processo.isf.isf_manufacturer) {
        this.errors += "O MANUFACTURER é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_seller) {
        this.errors += "O SELLER é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_buyer) {
        this.errors += "O BUYER é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_ship) {
        this.errors += "O SHIP é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_container) {
        this.errors += "O CONTAINER é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_consolidator) {
        this.errors += "O CONSOLIDATOR é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_importer) {
        this.errors += "O IMPORTER é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_cnee) {
        this.errors += "O CNEE é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_country) {
        this.errors += "O COUNTRY é obrigatório. \r\n";
      }
      if (!this.processo.isf.isf_hts) {
        this.errors += "O HTS é obrigatório. \r\n";
      }

      alert(this.errors);
      return false;
    },
    calcularWeight() {
      let soma = 0;
      this.processo.containers.content.forEach((element) => {
        if (element.GROSSWEIGHT) {
          soma += parseFloat(element.GROSSWEIGHT);
        }
        this.processo.gross_weight = soma;
      });
      return soma;
    },
    calcularMeasurement() {
      let soma = 0;
      this.processo.containers.content.forEach((element) => {
        if (element.CBM) {
          soma += parseFloat(element.CBM);
        }
        this.processo.measurement = soma;
      });
      return soma;
    },
    calcularQuantity() {
      return this.processo.containers.content.length;
    },
  },
  created() {

  },
  mounted() {
    this.checkEmpresaInfo();
  },
  updated() {

  },
  watch: {},
};
</script>
<style>
p,
span,
input,
textarea,
td,
pre,
input {
  font-size: 14px;
}

.break-row {
  white-space: pre-wrap;
  word-break: normal;
  width: 100%;
  display: -webkit-inline-box !important;
}

#card-with-table .table-responsive {
  overflow: auto !important;
}

.next-link,
.prev-link,
.current-link {
  padding: 10px;
}

.prev-link,
.next-link {
  cursor: pointer;
  background: #1dc7ea;
  border-radius: 4px;
}

#Page input::-webkit-outer-spin-button,
#Page input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prev-link i,
.next-link i {
  color: white;
}

.prev-link:hover,
.next-link:hover {
  background: #18a6c3;
}

.current-link {
  padding: 10px;
}

.timeline {
  border-left: 1px solid;
}

.timeline-item {
  position: relative;
  margin: 0em 0 0 28px !important;
  padding-bottom: 0;
  border-bottom: 1px dotted var(--timelineTheme);
}

.timeline-item p {
  font-size: 12px !important;
}

.info-header-capa h3 {
  font-size: x-large;
}

.info-header-capa p {
  font-size: 12px;
  margin: 0px;
  padding: 0px;
}

.dropdown-item .router-link-exact-active,
.dropdown-item.active {
  background: #1dc7ea;
  color: white;
}

.max-180 {
  max-width: 210px;
}

h3 {
  margin-top: 0px;
  padding-top: 5px;
  font-size: 20px;
}

.data {
  font-weight: bold;
}

.pagebreak {
  clear: both;
  page-break-before: always;
}

.dfl {
  font-size: x-small;
  padding: 0px;
  margin: 0px;
  display: block;
}

.ft-11{
  font-size: 11px !important;
}

@media print {
  #print {
    margin-left: -500px;
    z-index: 9999;
  }

  .pagebreak {
    clear: both;
    page-break-before: always;
  }



  /* page-break-after works, as well */
}</style>